
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Capa_2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Social"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M14.1 20.2c-.44-.03-.8.33-.8.76v2.3c0 .4.31.74.71.76 5.35.35 9.64 4.62 9.98 9.98.02.4.36.71.76.71h2.31c.44.01.79-.35.76-.79-.4-7.4-6.33-13.33-13.73-13.73z"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"16.5","cy":"31.5","r":"3.21"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M14.08 13.29a.754.754 0 00-.79.76v2.3c0 .41.33.74.74.76 9.15.38 16.49 7.72 16.86 16.86.01.41.35.74.76.74h2.3c.43 0 .78-.36.76-.79-.4-11.18-9.4-20.24-20.64-20.64z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M24 0C10.75 0 0 10.75 0 24s10.75 24 24 24 24-10.75 24-24S37.25 0 24 0zm15 35.79c0 1.77-1.44 3.21-3.21 3.21H12.21C10.44 39 9 37.56 9 35.79V12.21C9 10.44 10.44 9 12.21 9h23.57c1.77 0 3.21 1.44 3.21 3.21v23.57z"}})])])
          )
        }
      }
    